import { WidgetHelper } from './Widget';
import { WidgetType } from './widgetType';
export const MultipleResponseQuestionHelper = {
    create: (id, trackingIdentifier, questionText, options, properties, feedback, titleAssetId) => {
        const moreThanSingleCorrectAnswer = options.filter((option) => option.isCorrect).length >= 1;
        if (!moreThanSingleCorrectAnswer) {
            throw Error('Multiple answers question widget does not contain single correct answer');
        }
        const data = {
            questionText,
            options,
            feedbackIncorrect: feedback.feedbackIncorrect,
            feedbackCorrect: feedback.feedbackCorrect,
            titleAssetId,
        };
        return WidgetHelper.buildWidget(id, trackingIdentifier, data, properties, WidgetType.multipleResponseQuestion);
    },
    isMultipleResponseWidget: (widget) => {
        return widget.value.type === WidgetType.multipleResponseQuestion;
    },
};
